import { Palette } from '../../types'
import { fetchCompanyPalettes } from '../../services/palettes.service'
import { actions as customActions } from './palettes.actions'
import { getters as customGetters } from './palettes.getters'
import { state as customState } from './palettes.state'
import { mutations as customMutations } from './palettes.mutations'
import createBaseStore from '../createStoreHelper'

export const PalettesModule: any = createBaseStore<Palette>({
  resourceName: 'palettes',
  apiCalls: {
    fetchAllApiCall: fetchCompanyPalettes
  }
})

PalettesModule.actions = { ...PalettesModule.actions, ...customActions }
PalettesModule.getters = { ...PalettesModule.getters, ...customGetters }
PalettesModule.state = { ...PalettesModule.state, ...customState }
PalettesModule.mutations = { ...PalettesModule.mutations, ...customMutations }
